module.exports = __webpack_public_path__ + "media/images/flashcard_usage-81175bb5.gif";